module.exports = __webpack_public_path__ + "static/media/opencv_logo.60399d27.png";